// Games are no longer embedded in the /stages payload — they come from the dedicated
// by-context endpoint. This merges that flat games list back onto the stages tree by
// gamedayId, reconstructing `gameday.games` so all existing tree/schedule components keep
// working unchanged.
const attachGamesToStages = (stages = [], games = []) => {
  const byGameday = new Map()
  ;(games || []).forEach((game) => {
    if (!game?.gamedayId) return
    if (!byGameday.has(game.gamedayId)) byGameday.set(game.gamedayId, [])
    byGameday.get(game.gamedayId).push(game)
  })

  return (stages || []).map((stage) => ({
    ...stage,
    groups: (stage.groups || []).map((group) => ({
      ...group,
      gamedays: (group.gamedays || []).map((gameday) => ({
        ...gameday,
        games: byGameday.get(gameday.id) || [],
      })),
    })),
  }))
}

export default attachGamesToStages
